import React from "react";
import { Box, VStack, Text, Link as ChakraLink } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { FaHeart, FaWallet, FaSuitcase } from "react-icons/fa";
import { ReactComponent as ChatIcon } from "../../assets/icons/chat_fill_message_communication_icon.svg";
import { ReactComponent as ItineraryIcon } from "../../assets/icons/noun-travel-itinerary-4236219.svg";

const ACTIVE_COLOR = "#286328"; // your brand green

const MobileBottomNav = () => {
  const { pathname } = useLocation(); // 🔍 current route

  const navLinks = [
    { to: "/ai-travel-planner/chat", text: "Chat", icon: ChatIcon },
    { to: "/ai-travel-planner/bucket-list", text: "Bucket List", icon: FaHeart },
    {
      to: "/ai-travel-planner/ongoing-trip",
      text: "Ongoing Trip",
      icon: ItineraryIcon,
    },
    {
      to: "/ai-travel-planner/budget-planner",
      text: "Budget Planner",
      icon: FaWallet,
    },
    {
      to: "/ai-travel-planner/packing-list",
      text: "Packing List",
      icon: FaSuitcase,
    },
  ];

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      h="64px"
      py={1}
      px={2}
      bg="white"
      borderTop="1px solid"
      borderColor="blackAlpha.200"
      display={{ base: "flex", md: "none" }}
      justifyContent="space-around"
      alignItems="center"
      zIndex="banner"
    >
      {navLinks.map(({ to, text, icon: Icon }, i) => {
        const isActive = pathname.startsWith(to); // simple match
        const iconProps =
          Icon === ChatIcon || Icon === ItineraryIcon
            ? { fill: isActive ? ACTIVE_COLOR : "black" } // svg imports
            : { color: isActive ? ACTIVE_COLOR : "black" }; // react‑icons

        return (
          <VStack
            key={i}
            spacing={0}
            as={ChakraLink}
            to={to}
            component={Link}
            _hover={{ textDecoration: "none", color: "black" }}
          >
            <Icon width="20px" height="15px" {...iconProps} />
            <Link to={to}>
              <Text
                fontSize="xs"
                mt={1}
                mb={0}
                fontWeight={isActive ? "bold" : "normal"}
                color={isActive ? ACTIVE_COLOR : "black"}
              >
                {text}
              </Text>
            </Link>
          </VStack>
        );
      })}
    </Box>
  );
};

export default MobileBottomNav;
